import {TableActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import {TableIndicatorStatus} from 'notebook/tables/TableConstants';
import APIUtil from 'util/APIUtil';

export interface TableActionButtonDisabledParams<TTableMetadata, TRowMetadata>
  extends Pick<
    TableActionFunctionParameters<TTableMetadata, TRowMetadata>,
    'entryOrTemplateId' | 'structuredTable' | 'locked' | 'tableStatus'
  > {}

/**
 * Returns true if:
 * the entry is locked,
 * or if the table is in config mode,
 * or if we're in a template,
 * or if the table status is not UNSUBMITTED_CHANGES or HAS_BYPASSABLE_ERRORS.
 * In most cases, we do not want to call the backend action function if any of these cases are true.
 */
export default function isTableActionButtonDisabled<TTableMetadata, TRowMetadata>({
  entryOrTemplateId,
  structuredTable,
  locked,
  tableStatus,
}: TableActionButtonDisabledParams<TTableMetadata, TRowMetadata>): boolean {
  return (
    locked ||
    structuredTable.isConfig ||
    (entryOrTemplateId != null && APIUtil.isEntryOrSubOrWorkflowTemplate(entryOrTemplateId)) ||
    // Only statuses where button is enabled are UNSUBMITTED_CHANGES and HAS_BYPASSABLE_ERRORS
    (tableStatus !== TableIndicatorStatus.UNSUBMITTED_CHANGES &&
      tableStatus !== TableIndicatorStatus.HAS_BYPASSABLE_ERRORS)
  );
}
